import { baseApiClient as api } from "../baseService";

export const addTagTypes = ["provider-directory-v2"] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      providerDirectoryV2GooglePlacesAutocomplete: build.query<
        ProviderDirectoryV2GooglePlacesAutocompleteApiResponse,
        ProviderDirectoryV2GooglePlacesAutocompleteApiArg
      >({
        query: (queryArg) => ({
          url: `/api/provider-directory/v2/google/places/autocomplete/`,
          params: {
            center_lat: queryArg.centerLat,
            center_lng: queryArg.centerLng,
            q: queryArg.q,
            radius_m: queryArg.radiusM,
            session_token: queryArg.sessionToken,
            strict_bounds: queryArg.strictBounds,
          },
        }),
        providesTags: ["provider-directory-v2"],
      }),
      providerDirectoryV2GooglePlacesDetails: build.query<
        ProviderDirectoryV2GooglePlacesDetailsApiResponse,
        ProviderDirectoryV2GooglePlacesDetailsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/provider-directory/v2/google/places/details/`,
          params: {
            place_id: queryArg.placeId,
            session_token: queryArg.sessionToken,
          },
        }),
        providesTags: ["provider-directory-v2"],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as enhancedApi };
export type ProviderDirectoryV2GooglePlacesAutocompleteApiResponse =
  /** status 200  */ GooglePlacesAutocompleteResponseV2;
export type ProviderDirectoryV2GooglePlacesAutocompleteApiArg = {
  /** Optional latitude for location bias. */
  centerLat?: number;
  /** Optional longitude for location bias. */
  centerLng?: number;
  /** User search query. */
  q: string;
  /** Optional bias radius in meters. */
  radiusM?: number;
  /** UUIDv4 session token for Places billing session. */
  sessionToken: string;
  /** Optional: when true, restrict results to within (center,radius). When false, bias only. If omitted, server will try strict first (when center is provided) and broaden automatically if needed. */
  strictBounds?: boolean;
};
export type ProviderDirectoryV2GooglePlacesDetailsApiResponse =
  /** status 200  */ GooglePlaceDetailsV2;
export type ProviderDirectoryV2GooglePlacesDetailsApiArg = {
  /** Google place_id to resolve. */
  placeId: string;
  /** Same session token used for autocomplete. */
  sessionToken: string;
};
export type GooglePlacesAutocompletePredictionV2 = {
  /** Google place_id */
  place_id: string;
  /** Full prediction description */
  description: string;
  /** Primary label (usually place name) */
  main_text?: string | null;
  /** Secondary label (usually address/area) */
  secondary_text?: string | null;
};
export type GooglePlacesAutocompleteResponseV2 = {
  predictions: GooglePlacesAutocompletePredictionV2[];
};
export type GooglePlaceDetailsV2 = {
  place_id: string;
  name: string;
  formatted_address?: string | null;
  address_line1?: string | null;
  address_line2?: string | null;
  city?: string | null;
  state?: string | null;
  postal_code?: string | null;
  country?: string | null;
  latitude?: number | null;
  longitude?: number | null;
  phone_number?: string | null;
  website?: string | null;
};
export const {
  useProviderDirectoryV2GooglePlacesAutocompleteQuery,
  useProviderDirectoryV2GooglePlacesDetailsQuery,
} = injectedRtkApi;
